import httpClient from '../../utils/httpClient';

export async function getIntercomAuthToken() {
  try {
    const response = await httpClient().get('/request-token');
    const { data } = response;

    return data;
  } catch (error) {
    console.error('Error intercom token:', error);
    throw error;
  }
}
